import React from "react";
import { useGenericContext } from "@wdpr/groot-components";
import { WdprSearchInput } from "components/vista";

const semiExpandedSearchInputClass =
	"syndicated-navigation__nav__search-semiexpanded";

/**
 * Semi-expanded search input shown on the search results page in mobile view.
 * Renders flat (no drop shadow/background) and pre-filled with the current
 * query term. Tapping it re-expands the full search experience via the
 * `onExpand` callback.
 *
 * Page detection and brand gating are resolved by the parent (NavigationTxp)
 * through the brand's `txp.searchSemiExpandedPaths` config, so this component
 * only renders the input.
 */
const SemiExpandedSearchInput = ({
	onExpand,
	onMouseEnter,
	onMouseLeave,
	draftValue,
}) => {
	const {
		headerData: { chrome },
	} = useGenericContext();

	const urlSearchQuery =
		typeof window === "undefined"
			? ""
			: new URLSearchParams(window.location.search).get("searchQuery") || "";
	const semiExpandedSearchQuery =
		typeof draftValue === "string" ? draftValue : urlSearchQuery;

	return (
		<div
			className={semiExpandedSearchInputClass}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
		>
			<WdprSearchInput
				showLeadingIcon={false}
				label={chrome?.searchDisney}
				value={semiExpandedSearchQuery}
				inputHardcodedValue={semiExpandedSearchQuery}
				customTabindex="0"
				name="searchQuery"
				size="medium"
				// Tapping the bar opens the full search with the current term;
				// tapping the trailing (clear) button opens it empty.
				// Tapping the bar opens the full search with the current term;
				// tapping the trailing (clear) button opens it empty.
				onInputClick={() => onExpand?.({ clear: false })}
				onTrailingClick={() => onExpand?.({ clear: true })}
			></WdprSearchInput>
		</div>
	);
};

export default SemiExpandedSearchInput;
